import React, { useState } from "react";

/**
 * Reusable password field with show/hide toggle.
 * - Same visual as your .ui-input fields
 * - Works inside forms (no extra state mgmt needed)
 */
export default function PasswordInput({
  value,
  onChange,
  placeholder = "Password",
  required = false,
  name = "password",
  autoComplete = "current-password",
  ...rest
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="pw-wrap">
      <input
        className="ui-input"
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        name={name}
        autoComplete={autoComplete}
        {...rest}
      />
      <button
        type="button"
        className="pw-toggle"
        aria-label={show ? "Hide password" : "Show password"}
        onClick={() => setShow((s) => !s)}
      >
        {show ? "🙈" : "👁️"}
      </button>
    </div>
  );
}